<template>
    <div>
        <h1>这是图表封装演示</h1>
        <echarts :chartData="echartsData" style="height: 240px;" :isAxisChart="true"></echarts>
    </div>
</template>

<script>
import Echarts from "@/components/Echarts";
import Mock from 'mockjs'
// 图表数据
let List = []
for (let i = 0; i < 7; i++) {
    List.push({
        苹果: Mock.Random.float(100, 8000, 0, 0),
        vivo: Mock.Random.float(100, 8000, 0, 0),
        oppo: Mock.Random.float(100, 8000, 0, 0),
        魅族: Mock.Random.float(100, 8000, 0, 0),
        三星: Mock.Random.float(100, 8000, 0, 0),
        小米: Mock.Random.float(100, 8000, 0, 0)
    })
}
let date = ['20191001', '20191002', '20191003', '20191004', '20191005', '20191006', '20191007']
export default {
    name: "",
    data() {
        return {
            echartsData: {
                xData: [],
                series: []
            }
        }
    },
    components: {
        Echarts
    },
    methods: {
        getTableData() {
            // 传给组件的值
            this.echartsData.xData = date
            this.echartsData.series = [
                { name: '苹果', data: List.map((item) => item['苹果']), type: 'line'},
                { name: 'vivo', data: List.map((item) => item['vivo']), type: 'line'},
                { name: 'oppo', data: List.map((item) => item['oppo']), type: 'line'},
                { name: '魅族', data: List.map((item) => item['魅族']), type: 'line'},
                { name: '三星', data: List.map((item) => item['三星']), type: 'line'},
                { name: '小米', data: List.map((item) => item['小米']), type: 'line'}
            ]
        }
    },
    mounted () {
        this.getTableData()
    }
}
</script>

<style scoped>

</style>
